interface IAppendSurvicateScriptProps {
  urlWorkspace: string;
  visitorTraitsData?: Record<string, string>;
}
export const appendSurvicateScript = ({ urlWorkspace, visitorTraitsData = {} }: IAppendSurvicateScriptProps) => {
  const scriptTag = document.createElement('script');
  scriptTag.type = 'text/javascript';
  scriptTag.dataset.testid = 'survicate-script';
  scriptTag.text = `
    (function(w) {
      var s = document.createElement('script');
      s.src = '${urlWorkspace}';
      s.async = true;
      var e = document.getElementsByTagName('script')[0];
      e.parentNode.insertBefore(s, e);
    })(window);

    (function(opts) {
      opts.traits = ${JSON.stringify(visitorTraitsData)}
    })(window._sva = window._sva || {});
    `;
  document.body.appendChild(scriptTag);
};
